<template>
    <transition appear name="slide-fade">
        <div v-if="active" class="user-profile" :key="'profile-modal'">
            <Closer @click="hide()"/>
            <transition appear name="fade" mode="out-in">
                <div v-if="user" class="profile-space" :key="'profile-'+Date.now()">
                    <h1 class="headline">{{ user.username }}<VerifiedStamp v-if="1 === user.isVerified"/></h1>
                    <div class="top-box">
                        <div class="user-image"></div>
                        <div class="basics">
                            <div class="info-row">
                                {{ user.name }}
                            </div>
                            <div class="info-row">
                                {{ $core.getFriendlyTimestamp().friendlyDate( user.dateBirthday ) }}
                            </div>
                            <div class="info-row">
                                {{ $core.getFriendlyTimestamp().getAgeFromDate( user.dateBirthday ) }}
                            </div>
                            <div class="info-row">
                                {{ user.gender }}
                            </div>
                            <div class="info-row">
                                {{ user.zipCode }}
                            </div>
                        
                        </div>
                    </div>
                </div>
                <Spinner v-else mode="fullscreen"/>
            </transition>
        </div>
    </transition>
</template>
<script>
import Closer from "@/components/layout/parts/Closer.vue";
import Spinner from "@/components/layout/parts/Spinner.vue";
import VerifiedStamp from "@/components/layout/parts/VerifiedStamp.vue";

export default {
    
    name:       'UserProfile',
    components: { VerifiedStamp, Spinner, Closer },
    data()
    {
        return {
            active: false,
            userId: false,
            user:   false
        }
    },
    
    created()
    {
        
        this.$core
            .getEventManager()
            .add( 'on-show-user-profile', ( which ) =>
            {
                
                this.userId = which
                this.active = true
                this.refresh()
                
            } )
        
    },
    
    mounted()
    {
        this.refresh()
    },
    
    beforeUnmount()
    {
        
        this.$core
            .getEventManager()
            .remove( 'on-show-user-profile' )
        
    },
    
    methods: {

        refresh()
        {
            console.log( {
                method:  'users.getFullUserInfo',
                id_user: this.userId
            } )
            
            this.$core
                .getClient()
                .request( {
                    method:  'users.getFullUserInfo',
                    id_user: this.userId
                } )
                .then( ( response ) => {
                    
                    this.user = response.result
                    
                })
            
        },
        
        hide()
        {
            this.active = false
            this.userId = false
            this.user = false
        }
        
    }
}
</script>